import { render, staticRenderFns } from "./StudentIndicator.vue?vue&type=template&id=7479b2ab&scoped=true"
import script from "./StudentIndicator.vue?vue&type=script&lang=js"
export * from "./StudentIndicator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7479b2ab",
  null
  
)

export default component.exports